__turbopack_context__.v({
  "DM_12_24_Link_B": "Required2FAOverlay-module-scss-module__G1-33G__DM_12_24_Link_B",
  "DM_14_24_Link_B": "Required2FAOverlay-module-scss-module__G1-33G__DM_14_24_Link_B",
  "DM_20_24_Bold": "Required2FAOverlay-module-scss-module__G1-33G__DM_20_24_Bold",
  "DM_Body_Reg_16": "Required2FAOverlay-module-scss-module__G1-33G__DM_Body_Reg_16",
  "DM_Bold_14_16": "Required2FAOverlay-module-scss-module__G1-33G__DM_Bold_14_16",
  "DM_Bold_14_24_UC": "Required2FAOverlay-module-scss-module__G1-33G__DM_Bold_14_24_UC",
  "DM_Bold_16_24": "Required2FAOverlay-module-scss-module__G1-33G__DM_Bold_16_24",
  "DM_Bold_20_24": "Required2FAOverlay-module-scss-module__G1-33G__DM_Bold_20_24",
  "DM_Bold_40_56": "Required2FAOverlay-module-scss-module__G1-33G__DM_Bold_40_56",
  "DM_Btn_16_16_Med": "Required2FAOverlay-module-scss-module__G1-33G__DM_Btn_16_16_Med",
  "DM_Med_10_12": "Required2FAOverlay-module-scss-module__G1-33G__DM_Med_10_12",
  "DM_Med_12_12_Chip": "Required2FAOverlay-module-scss-module__G1-33G__DM_Med_12_12_Chip",
  "DM_Med_12_16": "Required2FAOverlay-module-scss-module__G1-33G__DM_Med_12_16",
  "DM_Med_14_16": "Required2FAOverlay-module-scss-module__G1-33G__DM_Med_14_16",
  "DM_Med_14_20": "Required2FAOverlay-module-scss-module__G1-33G__DM_Med_14_20",
  "DM_Med_14_24": "Required2FAOverlay-module-scss-module__G1-33G__DM_Med_14_24",
  "DM_Med_16_16": "Required2FAOverlay-module-scss-module__G1-33G__DM_Med_16_16",
  "DM_Med_16_24": "Required2FAOverlay-module-scss-module__G1-33G__DM_Med_16_24",
  "DM_Med_18_24": "Required2FAOverlay-module-scss-module__G1-33G__DM_Med_18_24",
  "DM_Med_20_24": "Required2FAOverlay-module-scss-module__G1-33G__DM_Med_20_24",
  "DM_Med_24_24": "Required2FAOverlay-module-scss-module__G1-33G__DM_Med_24_24",
  "DM_Med_32_32": "Required2FAOverlay-module-scss-module__G1-33G__DM_Med_32_32",
  "DM_Med_32_48": "Required2FAOverlay-module-scss-module__G1-33G__DM_Med_32_48",
  "DM_Med_8_8": "Required2FAOverlay-module-scss-module__G1-33G__DM_Med_8_8",
  "DM_Reg_10_10": "Required2FAOverlay-module-scss-module__G1-33G__DM_Reg_10_10",
  "DM_Reg_12_12_Chip": "Required2FAOverlay-module-scss-module__G1-33G__DM_Reg_12_12_Chip",
  "DM_Reg_12_16": "Required2FAOverlay-module-scss-module__G1-33G__DM_Reg_12_16",
  "DM_Reg_14_16": "Required2FAOverlay-module-scss-module__G1-33G__DM_Reg_14_16",
  "DM_Reg_14_24": "Required2FAOverlay-module-scss-module__G1-33G__DM_Reg_14_24",
  "DM_Reg_14_32_Table": "Required2FAOverlay-module-scss-module__G1-33G__DM_Reg_14_32_Table",
  "DM_Reg_16_16_Chip": "Required2FAOverlay-module-scss-module__G1-33G__DM_Reg_16_16_Chip",
  "DM_Reg_16_20": "Required2FAOverlay-module-scss-module__G1-33G__DM_Reg_16_20",
  "DM_Reg_16_24": "Required2FAOverlay-module-scss-module__G1-33G__DM_Reg_16_24",
  "DM_Reg_16_24_Italic": "Required2FAOverlay-module-scss-module__G1-33G__DM_Reg_16_24_Italic",
  "DM_Reg_18_28": "Required2FAOverlay-module-scss-module__G1-33G__DM_Reg_18_28",
  "DM_Reg_32_32": "Required2FAOverlay-module-scss-module__G1-33G__DM_Reg_32_32",
  "DM_Reg_40_56": "Required2FAOverlay-module-scss-module__G1-33G__DM_Reg_40_56",
  "backdrop": "Required2FAOverlay-module-scss-module__G1-33G__backdrop",
  "container": "Required2FAOverlay-module-scss-module__G1-33G__container",
  "content": "Required2FAOverlay-module-scss-module__G1-33G__content",
  "description": "Required2FAOverlay-module-scss-module__G1-33G__description",
  "header": "Required2FAOverlay-module-scss-module__G1-33G__header",
  "modal": "Required2FAOverlay-module-scss-module__G1-33G__modal",
  "wider": "Required2FAOverlay-module-scss-module__G1-33G__wider",
});
